import $ from 'jquery';

export default () => {
  const $window = $(window);

  $('.menu--media-resources-menu').on('click', '.nav-tabs-toggler', function(e) {
    e.preventDefault();

    const $this = $(this);
    const $target = $this.data('target');

    $($target).toggleClass('display-none');
  });

  $('.accordion-list').on('click', '.li-content-toggler', function(e) {
    e.preventDefault();

    const $this = $(this);
    const $target = $this.closest('li').find('.li-content');
    const offsetTop = $this.offset().top;
    const scrollTop = $window.scrollTop();

    // If target is not already expanded.
    if (!$this.hasClass('up')) {
      // Collapse others .li-text in accordion.
      const $accordion = $this.closest('.accordion-list');

      if ($accordion.length == 1) {
        $('.li-content', $accordion).hide();
        $('.li-content-toggler', $accordion).removeClass('up');
      }
    }

    if ($target.length > 0) {
      $target.toggle();
      $this.toggleClass('up');
      $window.scrollTop($this.offset().top - (offsetTop - scrollTop));
    }
  });

  $(document).on('click', '.accordion .accordion-toggle', function(e) {
    e.preventDefault();
    $(this).closest('.accordion').toggleClass('active');
    e.stopPropagation();
  });

  $('.accordion').on('click', '.accordion-item-trigger', function(event) {
    const $currentItem = $(this).closest('.accordion-item');
    const $allItems = $(this).closest('.accordion').find('.accordion-item');

    if ($currentItem.hasClass('active')) {
      $currentItem.removeClass('active')
    } else {
      $allItems.removeClass('active');
      $currentItem.addClass('active');
    }
  });
};
